import React from 'react';

export interface RoostingBrandLockupProps {
  /** Mark width and height in pixels. */
  size: number;
  /** Tailwind class controlling wordmark text size. Defaults to 'text-xl'. */
  wordmarkClassName?: string;
  /** Wordmark text. Defaults to 'Roosting'. */
  wordmarkText?: string;
}

const RoostingBrandLockup: React.FC<RoostingBrandLockupProps> = ({
  size,
  wordmarkClassName = 'text-xl',
  wordmarkText = 'Roosting',
}) => {
  return (
    <>
      <img
        src="/roosting-mark.svg"
        alt=""
        width={size}
        height={size}
        className="block flex-shrink-0"
      />
      <span
        className={`font-we-display font-black tracking-[-0.025em] text-we-ink ${wordmarkClassName}`}
      >
        {wordmarkText}
      </span>
    </>
  );
};

export default RoostingBrandLockup;
